import React, {useState} from "react";
import {useNavigate} from "react-router-dom";
import {Card} from "@radix-ui/themes";
import {CognitoUser} from 'amazon-cognito-identity-js'
import LoginService from "../service/loginService";

export default function LoginView() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [error, setError] = useState("");
    const [isPasswordChangeRequired, setIsPasswordChangeRequired] = useState(false);
    const [cognitoUser, setCognitoUser] = useState<CognitoUser | null>(null);

    const navigate = useNavigate();

    const submit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        try {
            const result = await LoginService.doLogin(
                {email, password, companyName: "MyCompany"},
                {
                    user_pool_id: "us-east-1_af2GRumEQ",
                    app_client_id: "28qrq8nr4tih8odvf11ufs1a9s",
                }
            );

            if (result.newPasswordRequired && result.cognitoUser) {
                setIsPasswordChangeRequired(true);
                setCognitoUser(result.cognitoUser);
            } else if (result.jwtToken) {
                localStorage.setItem("authToken", result.jwtToken);
                localStorage.setItem("email", email);
                navigate("/#");
            } else {
                setError("Erro ao fazer login. Verifique suas credenciais.");
            }
        } catch (err) {
            setError("Erro inesperado. Por favor, tente novamente.");
        }
    };

    const passwordChange = async () => {
        if (!cognitoUser || !newPassword) {
            setError("Erro ao alterar senha. Por favor, tente novamente.");
            return;
        }
    
        try {
            const result = await LoginService.completeNewPasswordChallenge(
                newPassword,
                cognitoUser,
                {
                    user_pool_id: "us-east-1_af2GRumEQ",
                    app_client_id: "28qrq8nr4tih8odvf11ufs1a9s",
                },
            );
    
            if (result.status === "Success") {
                alert("Senha alterada com sucesso! Faça login novamente.");
                setIsPasswordChangeRequired(false);
                setCognitoUser(null);
                setNewPassword("");
            } else {
                setError("Erro ao alterar senha. Por favor, tente novamente.");
            }
        } catch (err) {
            console.error(err);
            setError("Erro ao alterar senha. Por favor, tente novamente.");
        }
    };

    if (isPasswordChangeRequired) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <Card className="w-96 p-8 bg-white shadow-lg rounded-lg">
                    <h1 className="text-3xl font-semibold text-[#2294ae] text-center mb-6">Alterar Senha</h1>

                    <div className="mb-4">
                        <label htmlFor="newPassword" className="block text-lg font-medium text-[#2294ae] mb-2">Nova Senha</label>
                        <input type="password" id="newPassword" className="w-full px-4 py-2 border rounded-md text-gray-800 focus:outline-none focus:ring-2 focus:ring-[#2294ae]" placeholder="Digite sua nova senha" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} required />
                    </div>

                    {error && <p className="text-red-500 text-sm text-center mb-4">{error}</p>}

                    <button onClick={passwordChange} className="w-full py-2 bg-[#2294ae] text-white font-bold rounded-md hover:bg-[#1c7c92] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#2294ae]">
                        Alterar Senha
                    </button>
                </Card>
            </div>
        );
    }

    return (
        <div className="min-h-screen flex items-center justify-center">
            <Card className="w-96 p-8 bg-white shadow-lg rounded-lg">
                <h1 className="text-3xl font-semibold text-[#2294ae] text-center mb-6">Login</h1>

                <form onSubmit={submit}>
                    <div className="mb-4">
                        <label htmlFor="email" className="block text-lg font-medium text-[#2294ae] mb-2">Email</label>
                            <input type="email" id="email" className="w-full px-4 py-2 border rounded-md text-gray-800 focus:outline-none focus:ring-2 focus:ring-[#2294ae]" placeholder="Digite seu email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                        </div>

                        <div className="mb-6">
                            <label htmlFor="password" className="block text-lg font-medium text-[#2294ae] mb-2">Senha</label>
                            <input type="password" id="password" className="w-full px-4 py-2 border rounded-md text-gray-800 focus:outline-none focus:ring-2 focus:ring-[#2294ae]" placeholder="Digite sua senha" value={password} onChange={(e) => setPassword(e.target.value)} required />
                        </div>

                        {error && <p className="text-red-500 text-sm text-center mb-4">{error}</p>}

                        <button type="submit" className="w-full py-2 bg-[#2294ae] text-white font-bold rounded-md hover:bg-[#1c7c92] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#2294ae]">
                            Entrar
                        </button>
                    </form>

                    <p className="text-center text-gray-600 mt-4">
                        <a href="/recover" className="text-[#2294ae] hover:underline">
                            Esqueci a senha
                        </a>
                    </p>
                
                    <p className="text-center text-gray-600 mt-4">
                        Não tem uma conta? <a href="/signup" className="text-[#2294ae] hover:underline">Registre-se</a>
                    </p>
                </Card>
            </div>
    );
}